<template>
    <select ref="selectPicker" :class="_class" v-bind="$attrs" v-bind:value="value"  v-on="listeners">
        <slot></slot>
    </select>
</template>

<script>
import $ from 'jquery'

export default {
    props: {
        type: {
            type: String
        },
        is_last: {
            type: Boolean,
            default: false
        },
        size: {
            type: [Number, String],
            default: 5
        },
        value: {
            default: null
        },
        live_search: {
            type: Boolean,
            default: false
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    computed: {
        _class() {
            let _class = []

            _class.push('form-control')
             _class.push('kt-selectpicker')
            
            if(this.is_last === true) {
                _class.push('form-control-last')
            }

            return _class
        },
        listeners() {
            var vm = this
            return Object.assign({},
                this.$listeners,
                {
                    change: function (event) {
                        vm.$emit('change', event.target.value)
                    }
                }
            )
        },
    },
    mounted() {
        if(this.$refs.selectPicker) {
            $(this.$refs.selectPicker).selectpicker({
                size: this.size,
                liveSearch: this.live_search,
                noneResultsText: this.$t('selectpicker.none_result'),
                selectAllText: this.$t('selectpicker.select_all'),
                noneSelectedText: this.$t('selectpicker.nothing_selected')
            })
        }
    }
}
</script>